/** @format */

import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface NotificationItem {
  id: string;
  date: string;
  msg: string;
  title: string;
  action?: boolean;
  type: "success" | "danger" | "info";
}

export type NotificationsList = NotificationItem[];

export interface NotificationsState {
  notifications: NotificationsList;
  status: "idle" | "loading" | "failed";
}

const initialState: NotificationsState = {
  notifications: [],
  status: "idle",
};

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setAddNotifications: (state, action: PayloadAction<NotificationItem>) => {
      state.notifications.push(action.payload);
    },
    setRemoveNotification: (state, action: PayloadAction<string>) => {
      const index = state.notifications.findIndex(
        (item) => item.id === action.payload,
      );
      state.notifications.splice(index, 1);
    },
  },
});

export const { setAddNotifications, setRemoveNotification } =
  notificationsSlice.actions;
export const selectNotifications = () => (state: RootState) =>
  state.notifications.notifications;

export default notificationsSlice.reducer;
